export const lottery = {
  lotteryPlay: "Play",
  lotteryResults: "Results",
  myLotteryTicket: "My Tickets",
  lotteryMyTickets: "My Lottery Tickets",
  lotteryBackBtn: "Back to Lotteries",
  lotteryMyBets: "My Bets",
  lotteryFloatButtonTitle: "Bets",
  lotteryTooltipText: "Show all my bets",
  lotteryDraw: "Draw",
  lotteryAnimal: "Animal",
  lotterySelectAnimal: "Select an animal",
  lotterySelectDraw: "Select a draw",
  lotteryAmount: "Amount",
  lotteryTotalBet: "Total Bet",
  lotteryBuyTicket: "Buy Ticket",
  lotteryCreateTicket: "Creating ticket",
  lotteryCreatedTicket: "Ticket(s) created successfully!",
  lotteryErrorTicket: "Error creating the ticket",
  lotteryHideResults: "Hide Results",
  lotteryShowResults: "Show Results",
  lotteryDrawActive: "Active Draw",
  lotteryErrorLoadingData: "Error loading data",
  lotteryErrorInput: "Please add at least one bet before playing.",
  lotteryErrorBalance: "Insufficient balance. Please reload your balance.",
  lotteryErrorBetAmount: "The minimum bet is 50 Bs.",
  lotteryErrorMinBetAmount: "Minimum bet is {{min}} Bs.",
  lotteryErrorMaxBetAmount: "Maximum bet is {{max}} Bs.",
  lotteryErrorBetStep: "Bets must be in multiples of {{step}} (50, 60, 70...).",
  lotteryBetHintMin: "Min {{min}} Bs",
  lotteryBetHintStep: "multiples of {{step}}",
  lotteryBetHintMax: "max {{max}} Bs",
  lotteryErrorSelectDrawAnimal: "Please select a draw, an animal and enter a valid bet amount.",
  lotteryMode: "You can only select up to 4 animals in Modern mode.",
  lotteryTicketCreatedMessage: "Ticket created successfully",
  lotteryTicketCreatedMessageError: "Error creating the ticket",
  lotteryCardGame: "Coming Soon",
  lotteryModalCode: "Ticket Code",
  lotteryModalDate: "Creation Date",
  lotteryModalTotal: "Total Amount",
  lotteryModalWon: "Won Amount",
  lotteryModalAnimals: "Played Animals",
  lotteryModalTitle: "Ticket Details",
  lotteryModalCancel: "Cancel",
  lotteryModalConfirm: "Accept",
  lotteryModalAmount: "Amount",
  lotteryModalNoTickets: "You don't have lottery tickets",
  lotteryTokenNotFound: "Token not found",
  lotteryActiveRouletteResults: "Active Roulette Results",
  lotteryGameWinner: "Winner",
  lotteryGamePrize: "No winners",

  lotteryModalInput: "Enter your bet amount",
  lotteryModalAddBet: "Add Bet",
  lotteryModalCancelBet: "Cancel",

  lotteryTraditional: "Traditional",
  lotteryModern: "Modern",
  selectLotteryType: "Select Lottery Type",
  results: "Results",
  resultLotteryModern: "Modern Lottery Result",
  resultLotteryTradicional: "Traditional Lottery Result",
  lotteryDate: "Lottery Date",
  lotteryNoResults: "No results available for this date",
};
